export const DASHBOARD_PATH = '/';
export const LOGIN_PATH = '/login';
